const {
  VITE_API_HOST,
  VITE_ENVIRONMENT: ENVIRONMENT,
  VITE_LAUNCH_DARKLY_SDK_KEY,
  VITE_GIT_PULL_REQUEST_ID,
  VITE_STRIPE_PUBLISHABLE_KEY,
  VITE_FRIDA_STRIPE_PUBLISHABLE_KEY,
} = import.meta.env;

let API_HOST = VITE_API_HOST ?? 'http://localhost:3001';
if (VITE_GIT_PULL_REQUEST_ID) {
  // "frida" here is the Heroku review app naming scheme, not brand logic: every app in the
  // monorepo talks to the same review-app API host.
  // eslint-disable-next-line @pm/architecture/no-brand-logic
  API_HOST = `https://frida-api-pr-${VITE_GIT_PULL_REQUEST_ID}.herokuapp.com`;
}
const LAUNCH_DARKLY_SDK_KEY =
  VITE_LAUNCH_DARKLY_SDK_KEY ?? '6a90451200b7a80e63f17f3e';

// New Frida account: VITE_FRIDA_STRIPE_PUBLISHABLE_KEY takes precedence when set. No service in
// this repo sets it any more — the Frida deploy moved to talkwithfrida/core — so Freddie and
// Purposemed fall through to VITE_STRIPE_PUBLISHABLE_KEY / the hardcoded shared-account key below.
// The branch is kept only because apps/frida still lives here; it goes when that workspace does.
// TODO (post-migration cleanup): set the shared key per-service in flightcontrol.json too
const STRIPE_PUBLISHABLE_KEY =
  VITE_FRIDA_STRIPE_PUBLISHABLE_KEY ??
  VITE_STRIPE_PUBLISHABLE_KEY ??
  (ENVIRONMENT === 'production'
    ? 'pk_live_51Jn9TVHmfhkgjy6M947UNfbwRPYh63dDjx5DLOknC3GCKhUGvsxp6KpOLKu7s6kM4Wo01RHQrloo9E9Di0xjRcR800hjn6N4rZ'
    : 'pk_test_51Jn9TVHmfhkgjy6Mk6qMPm5DVXQdmvryn1hZBp7UzWFlsFK3s8o86GFwJYiGqqcmg9wYzF480LJuLiEzU6sAzC0L00NQfXsWBk');
const DEFAULT_HOOK_FORM_VALIDATION_MODE: {
  mode: 'onTouched';
} = {
  mode: 'onTouched',
};

export {
  API_HOST,
  DEFAULT_HOOK_FORM_VALIDATION_MODE,
  ENVIRONMENT,
  LAUNCH_DARKLY_SDK_KEY,
  STRIPE_PUBLISHABLE_KEY,
};
